import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Checkbox, Button, Form, Input, Typography, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { login, verifyLogin } from '../services/User';

const { Text, Link } = Typography;


export default () => {
    let nav = useNavigate();


    useEffect(() => {
        
        let account = localStorage.getItem("accountInfo");
        if (account != null) {
            try {
                let objAccount = JSON.parse(account);
                if (objAccount != null) {
                    let loginParams: API.LoginParams = objAccount
                    if (objAccount.token && objAccount.token != "") {
                        console.log("尝试登陆")
                        login(loginParams).then((token) => {
                            objAccount.token = token;
                            localStorage.setItem("accountInfo", JSON.stringify(objAccount));
                            nav("/home", { replace: true });
                        }).catch((e)=>{
                            nav("/login", { replace: true });
                        });
                    }else{
                        nav("/login", { replace: true });
                    }
                }
            } catch (e) {
                console.log(e)
            }

        }else {
            nav("/login", { replace: true });
        }
    }, [])


    return (
        <></>
    )
}